"use client"

import React, { useState } from 'react'
import Image from 'next/image'

interface ImageWithFallbackProps {
  src: string
  alt: string
  className?: string
  width?: number
  height?: number
  sizes?: string
  priority?: boolean
  fetchPriority?: "high" | "low" | "auto"
  loading?: "lazy" | "eager"
  decoding?: "async" | "sync" | "auto"
  fallback?: string
}

export function ImageWithFallback({ 
  src, 
  alt, 
  className, 
  width, 
  height, 
  sizes,
  priority,
  fetchPriority,
  loading,
  decoding,
  fallback = '/placeholder-image.jpg' 
}: ImageWithFallbackProps) {
  const [imgSrc, setImgSrc] = useState(src)
  const [hasError, setHasError] = useState(false)

  const handleError = () => {
    if (!hasError) {
      setHasError(true)
      setImgSrc(fallback)
    }
  }

  if (width && height) {
    return (
      <Image
        src={imgSrc}
        alt={alt}
        width={width}
        height={height}
        className={className}
        sizes={sizes}
        priority={priority}
        fetchPriority={fetchPriority}
        loading={loading}
        decoding={decoding}
        onError={handleError}
      />
    )
  }

  return (
    <Image
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      width={500}
      height={300}
      sizes={sizes}
      priority={priority}
      fetchPriority={fetchPriority}
      loading={loading}
      decoding={decoding}
    />
  )
}
